export enum CookieConsentPopupLayoutEnum {
  BOX = 'box',
  CLOUD = 'cloud',
  BAR = 'bar'
}